import actions from './actions';
import reducer from './reducer';

const pendingPrescription = {
    actions,
    reducer,
    name: 'pendingPrescription',
};

export default pendingPrescription; 